import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { initSentry } from "@/utils/sentry";
import { initPostHog } from "@/utils/posthog";
import { registerVitePreloadRecovery } from "@/utils/vitePreloadRecovery";

// Initialize error tracking (no-ops if VITE_SENTRY_DSN is not set)
initSentry();
initPostHog();
registerVitePreloadRecovery();

// Register service worker unconditionally so showNotification() is available
// for foreground reflect notifications, independent of the legacy push-nudge
// feature flag (which controls WebPush subscriptions, not SW registration).
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((err) => {
    console.warn("[SW] Registration failed:", err);
  });
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
